import { render, staticRenderFns } from "./add_goals_evaluation.vue?vue&type=template&id=98dc6510&scoped=true"
import script from "./add_goals_evaluation.vue?vue&type=script&lang=js"
export * from "./add_goals_evaluation.vue?vue&type=script&lang=js"
import style0 from "./add_goals_evaluation.vue?vue&type=style&index=0&id=98dc6510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dc6510",
  null
  
)

export default component.exports